<template>
 <div class="aprogress-container">
    <div class="aprogress">
    <div class="abarOverflow">
      <div class="abar"  v-bind:style="styleObject"></div>
    </div>
    <div class="aprogress__info">
      <div class="form__introtext" v-html="content.data.form_invitation.header_0"></div>
      <div class="form__introcounter">
        {{ value }}
      </div></div
    >
  </div>
</div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: { counterData: Number },
  inject:["content"],
  data() {
    return {
      value: 0,
      max: 100000,
      showProgresBar: false,
      showBee: false,
      showPuff: false,
      countdown: "",
      styleObject: {
         transform : "rotate(45deg)",
      },
    };
  },
  created() {
    this.delayedShow();
  },
  methods: {
    delayedShow() {
      let delay = 2000;
      setTimeout(() => {
        this.showProgresBar = false;
      }, delay);
      setTimeout(() => {
        this.value = this.counterData;
      }, 2000);
      setTimeout(() => {
        this.countPosition();
        this.countCountdown();
      }, 2000);

    },
    countPosition: function () {
      const percent = (this.counterData / this.max) *180;
      // console.log(this.counterData / this.max)
      if (this.max >= this.counterData) {
        this.styleObject.transform = "rotate("+ (45+(percent)) +"deg)";
      } else {
        this.styleObject.transform = "rotate(225deg)";
      }
    },
    countCountdown: function () {
      if (this.value < this.max) {
        this.countdown = (this.max - this.value)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      } else {
        this.countdown = "0";
      }
    },
  },
};
</script>
<style scoped>
.aprogress {
  position: relative;
  margin: 4px;
  float: left;
  text-align: center;
}
.abarOverflow {
  /* Wraps the rotating .bar */
  position: relative;
  overflow: hidden; /* Comment this line to understand the trick */
  width: 21rem;
  height: 20rem;
  margin-bottom: 0; /* bring the numbers up */
}
.abar {
  position: absolute;
  top: 1.44rem;
  left: 1.75rem;
  width: 18rem;
  height: 18rem;
  border-radius: 50%;
  box-sizing: border-box;
  border: 15px solid #000; /* half gray, */
  border-bottom-color: #F5D11B; /* half azure */
  border-right-color: #F5D11B;
  transition: 2s all;
}
.aprogress__info {
  position: absolute;
  top: 5rem;
  left: 50%;
  transform: translateX(-50%);
}
.aprogress-container {
  position: relative;
}
</style>
